import CryptoJS from 'crypto-js';
import DOMPurify from 'dompurify';
import { EXIST_LOCAL_STORAGE } from '../constants';
import Cookies from 'js-cookie';
export var apiProgressBar = '';
export const setapiProgressBar = (per: any) => {
    apiProgressBar = per;
    //console.log(apiProgressBar);
};

export const alphabeticallyGrouping = (data = [], key: any) => {
    let result = data.reduce((r: any, e) => {
        // get first letter of name of current element
        let alphabet = e[key][0];

        // if there is no property in accumulator with this letter create it
        if (!r[alphabet]) r[alphabet] = { alphabet, record: [e] };
        // if there is push current element to children array for that letter
        else r[alphabet].record.push(e);

        // return accumulator
        return r;
    }, {});

    return Object.values(result);
};

export const removeDuplicateArray = (data: any, key: any) => {
    return [...new Map(data?.map((item: any) => [item[key], item])).values()];
};

export const objectToQueryString = (params: string | string[][] | Record<string, string> | URLSearchParams | undefined) => {
    const queryString = new URLSearchParams(params).toString();
    return `?${queryString}`;
};

/*
 * LetterAvatar
 *
 * Artur Heinze
 * Create Letter avatar based on Initials
 * based on https://gist.github.com/leecrossley/6027780
 */

export const letterAvatar = (name: string, size: number, colour = true) => {
    name = name || '';
    size = size || 60;
    // colour = colour || true;

    var colours = [
            '#1abc9c',
            '#2ecc71',
            '#3498db',
            '#9b59b6',
            '#34495e',
            '#16a085',
            '#27ae60',
            '#2980b9',
            '#8e44ad',
            '#2c3e50',
            '#f1c40f',
            '#e67e22',
            '#e74c3c',
            '#ecf0f1',
            '#95a5a6',
            '#f39c12',
            '#d35400',
            '#c0392b',
            '#bdc3c7',
            '#7f8c8d',
        ],
        nameSplit = String(name).toUpperCase().split(' '),
        initials,
        charIndex,
        colourIndex,
        canvas,
        context: any,
        dataURI;

    if (nameSplit.length == 1) {
        initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
    } else {
        initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
    }

    if (window.devicePixelRatio) {
        size = size * window.devicePixelRatio;
    }

    charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
    colourIndex = charIndex % 20;
    canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    context = canvas.getContext('2d');

    context.fillStyle = colour ? colours[colourIndex - 1] : 'transparent';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.font = Math.round(canvas.width / 2) + 'px Arial';
    context.textAlign = 'center';
    context.fillStyle = colour ? '#FFF' : '#454545';
    context.fillText(initials, size / 2, size / 1.5);

    dataURI = canvas.toDataURL();
    canvas = null;

    return dataURI;
};

export const isEmpty = (obj: {}) => {
    //console.log("object error--->", obj);
    if (obj) {
        return Object?.keys(obj)?.length === 0;
    } else {
        return false;
    }
};

export const getBase64FromUrl = async (url: RequestInfo | URL) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
    });
};

export const setStorage = (name: string, data: string) => {
    localStorage.setItem(name, typeof data === 'string' ? data : JSON.stringify(data));
};

export const getStorage = (name: string): string => {
    if (typeof window !== 'undefined') return localStorage.getItem(name) || '';
    return '';
};

export function toFixedTrunc(num?: number, decimals?: number) {
    if (!num || !decimals) return '0.00';
    const factor = Math.pow(10, decimals);
    return (Math.trunc(num * factor) / factor)?.toFixed(decimals);
}

export const removeStorage = (name?: string) => {
    if (!!name) {
        localStorage.removeItem(name);
    } else {
        Object.keys(EXIST_LOCAL_STORAGE).forEach((key) => {
            localStorage.removeItem(EXIST_LOCAL_STORAGE[key]);
        });
    }
}; // ✅ Set Cookie (Client-Side)
export const setStorageCookie = (name: string, data: string, days = 7) => {
    if (typeof window !== 'undefined') {
        Cookies.set(name, data, { expires: days });
    }
};

// ✅ Get Cookie (Client-Side)
export const getStorageCookie = (name: string) => {
    if (typeof window !== 'undefined') {
        return Cookies.get(name) || 'undefined';
    }
    return null; // Return `null` if on the server
};

// // ✅ Get Cookie (Server-Side in Next.js)
// export const setCookie = (name: string, data: string, days = 7) => {
//   const expires = new Date();
//   expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
//   document.cookie = `${name}=${encodeURIComponent(data)}; expires=${expires.toUTCString()}; path=/`;
// };

export const getCookie = (name: string): string | undefined => {
    const cookie = Cookies.get(name);
    return cookie;
};

export const removeCookie = async (name?: string) => {
    if (name) document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    else {
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

            // Try common paths
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${location.hostname}`;
        }
    }
};

export const removeStorageCookie = (name?: string) => {
    if (!!name) {
        Cookies.remove(name);
    } else {
        Object.keys(EXIST_LOCAL_STORAGE).forEach((key: any) => {
            Cookies.remove(EXIST_LOCAL_STORAGE[key]);
        });
    }
};

export const handleNumberRound = (num: number) => {
    return Math.round(num ? num : 0);
};

export function isFloat(n: any) {
    return Number(n) === n && n % 1 !== 0;
}

export const getSno = (index: number, data: any, perPageRecords: any) => {
    let page = index + 1;
    // //console.log("response", data);

    let pageNo = page + data?.page_no * perPageRecords - perPageRecords;
    return pageNo > data.total_records ? data.start_record + index : pageNo;
};

export const dateFormat = (date: any) => {
    let objectDate = new Date(date);
    let day = objectDate.getDate();

    let month = objectDate.getMonth() + 1;

    let year = objectDate.getFullYear();

    const m = month < 10 ? '0' + String(month) : month;
    const d = day < 10 ? '0' + String(day) : day;
    // //console.log(" dfgasdfsdf component", m , d); // 2022

    return year + '-' + m + '-' + d;
};

export const getWindowSize = () => {
    if (typeof window === 'undefined') return { innerWidth: 0 };
    const { innerWidth } = window;
    return { innerWidth };
};

export const getPlatform = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'IOS';
    } else if (/Android/.test(userAgent)) {
        return 'Android';
    } else if (platform.toLowerCase().includes('win')) {
        return 'Windows';
    } else if (/Mac/.test(platform)) {
        return 'Mac';
    } else {
        return 'Other platforms';
    }
};
export const getBrowserName = () => {
    const userAgent = window.navigator.userAgent;
    const browsers: Record<string, RegExp> = {
        Edge: /Edg\/\d+\.\d+(\.\d+)?/,
        Opera: /Opera\/(\S+)/,
        Chrome: /Chrome\/(\S+)/,
        Firefox: /Firefox\/(\S+)/,
        Safari: /Version\/(\S+).*Safari\/(\S+)/,
        MSIE: /MSIE (\S+);/,
    };

    for (const browser in browsers) {
        const match = userAgent.match(browsers[browser]);
        if (match) {
            return browser;
        }
    }
    return 'Other browsers';
};
export const getDevicePlatform = () => {
    const devicePlatform = getPlatform();
    const deviceBrowser = getBrowserName();
    return `${deviceBrowser} on ${devicePlatform}`;
};

// const todayDate = String(new Date().getUTCDate()).padStart(2, '0');
const password = 'Exchang3d@tA-EDI';
const key = CryptoJS.enc.Utf8.parse(password);
const options = { keySize: 128, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 };

export const getEncryptedText = (text: string): string | undefined => {
    if (!text) {
        return;
    }
    const utfConvertedText = CryptoJS.enc.Utf8.parse(text);
    const encryptedText = CryptoJS.AES.encrypt(utfConvertedText, key, options);
    const convertedEncryptedText = encryptedText.ciphertext.toString(CryptoJS.enc.Base64);
    return convertedEncryptedText;
};

export const getDecryptedText = (encryptedText: string) => {
    if (!encryptedText) {
        return;
    }
    const base64ConvertedText = CryptoJS.enc.Base64.parse(encryptedText);
    const decryptedText = CryptoJS.AES.decrypt({ ciphertext: base64ConvertedText }, key, options);
    const convertedDecryptedText = decryptedText.toString(CryptoJS.enc.Utf8);
    return convertedDecryptedText;
};

export const getUrlParams = (param: string) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramValue = urlParams.get(param);
    return paramValue;
};

export const getCommaSeperatedNumbers = (num: number | string) => {
    if (num) {
        return typeof num === 'number' ? num.toLocaleString() : parseFloat(num).toLocaleString();
    }
};

export const hasLowerCase = (str: string) => {
    return /[a-z]/.test(str);
};
export const hasUpperCase = (str: string) => {
    return /[A-Z]/.test(str);
};
export const hasNumber = (str: string) => {
    return /[0-9]/.test(str);
};
export const hasSpecialCharacter = (str: string) => {
    const format = /[@$!%*?&#-]/;
    return format.test(str);
};

export const getElementHeight = (element: HTMLElement) => {
    return element?.getBoundingClientRect()?.height;
};

export const convertPathNameToPageName = (pathName: string) => {
    if (pathName === '/') return 'Home';
    else if (pathName === '/screener') return 'Screener';
    else if (pathName.includes('/discussion')) return 'Discussion';
    else if (pathName.includes('/bond-detail')) return 'Bond Detail (Old)';
    else if (pathName.includes('/bonds')) return 'Bond Detail';
    else if (pathName === '/dashboard') return 'Dashboard';
    else if (pathName.includes('/portfolio')) return 'Portfolio';
    else if (pathName.includes('/myprofile')) return 'Profile';
    else if (pathName.includes('/login')) return 'Login';
    else if (pathName.includes('/registerpage')) return 'Registration';
    else if (pathName === '/privacy-policy') return 'Privacy Policy';
    else if (pathName.includes('/admin_panel')) return 'Admin Panel';
    else if (pathName.includes('/issuer-bonds')) return 'Issuer bonds';
    else if (pathName.includes('/partners')) return 'Partners';
    else if (pathName.includes('/forgot-password')) return 'Forgot password';
    else if (pathName.includes('/reset-password')) return 'Reset password';
    else if (pathName.includes('/issuers')) return 'Issuers index';
    else if (pathName.includes('/viewprofile')) return 'View profile';
    else if (pathName.includes('/terms-and-condition')) return 'Terms and condition';
    else if (pathName.includes('/activation')) return 'Account Activation';
    else if (pathName.includes('/registration-success')) return 'Registration Success';
    else return pathName;
};

export const getExactPath = (path: string) => {
    path = path || '/';

    if (path.substring(1).includes('/')) {
        path = path.substring(0, path.substring(1).indexOf('/') + 1);
    }
    path = path.startsWith('/') ? path : `/${path}`;

    return path;
};
export const encodeTextForSEO = (text: string) => {
    return text?.replaceAll('-', '﹣').replaceAll(' ', '-').replaceAll('/', '|').replaceAll('&', '%26');
};

export const decodeTextFromSEO = (text: string) => {
    return text?.replaceAll('-', ' ').replaceAll('﹣', '-').replaceAll('|', '/').replaceAll('%26', '&');
};
// export const getencodedTextForSEO = (text: string) => text?.replaceAll('-', '﹣').replaceAll(' ', '-').replaceAll('/', '|').replaceAll('&', '%26')
// export const getdecodedTextForSEO = (text: string) => text?.replaceAll('-', ' ').replaceAll('﹣', '-').replaceAll('|', '/')
export const getencodedTextForSEO = (text: string) =>
    text?.replaceAll('-', '﹣').replaceAll(' ', '-').replaceAll('/', '|').replaceAll('&', '~');

export const setEncodetext = (text: string) => {
    if (!text) return '';
    return (
        text
            .replaceAll(/\//g, '|')
            .replaceAll('&', '_and_')
            // .replace(/-/g, "_dash_") // Replace original hyphens first
            .replaceAll(' ', '-')
    );
};
export const getdecodedTextForSEO = (text: string) =>
    text
        ?.replaceAll('-', ' ')
        .replaceAll('﹣', '-')
        .replaceAll('|', '/')
        .replaceAll('_and_', '&')
        .replaceAll('%2C', ',')
        .replaceAll('%60', '`');
// export const getencodedTextForSEO = (text: string) => {
//   if (!text) return '';
//   return text
//     .replace(/\s+/g, '-')  // Replace spaces with hyphens
//     .replace(/\//g, '|')   // Replace forward slashes with vertical bars
//     .replace(/\./g, '~')   // Replace dots with tildes
//     .replace(/[^a-zA-Z0-9-|~]/g, ''); // Remove other special characters
// };

// export const getdecodedTextForSEO = (text: string) => {
//   if (!text) return '';
//   return text
//     .replace(/\|/g, '/')   // Replace vertical bars with forward slashes
//     .replace(/~/g, '.')    // Replace tildes with dots
//     .replace(/-/g, ' ');   // Replace hyphens with spaces
// };
export function getDividedArray<T>(array: T[], cols: number): T[][] {
    if (cols <= 0) throw new Error('Number of columns must be greater than 0');

    const size = Math.ceil(array.length / cols);
    return Array.from({ length: cols }, (_, i) => array.slice(i * size, (i + 1) * size));
}

export const decodeHTML = (stringToBeDecoded: string) => {
    var doc = new DOMParser().parseFromString(stringToBeDecoded, 'text/html');
    return doc.documentElement.textContent;
};

export function createChildElement(
    parentElement: HTMLElement,
    childElementTagName: string,
    childElementAttributes: { key: string; value: string }[]
) {
    if (parentElement) {
        const childElement = document.createElement(childElementTagName);

        childElementAttributes.forEach(({ key, value }) => {
            childElement.setAttribute(key, value);
        });

        parentElement.appendChild(childElement);
    }
}

export const removeOldMetaTags = (query: string): void => {
    try {
        const descriptionTags = document.head.querySelectorAll(query);

        if (descriptionTags.length <= 1) return;

        Array.from(descriptionTags)
            ?.slice(0, -1)
            .forEach((tag) => document.head.removeChild(tag));
    } catch (error) {
        console.error(`Error removing meta tags with query "${query}":`, error);
    }
};

export const isObjectsEqual = (obj1: Record<string, any>, obj2: Record<string, any>) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};

let sanitizer: typeof DOMPurify.sanitize;

if (typeof window !== 'undefined') {
    // Client-side
    sanitizer = DOMPurify.sanitize;
} else {
    // Server-side
    const { JSDOM } = require('jsdom');
    const window = new JSDOM('').window;
    const purify = DOMPurify(window);
    sanitizer = purify.sanitize;
}

export const getCleanedHTML = (html: string) => {
    return sanitizer(html);
};

export function timeAgo(dateString: string) {
    if (!dateString) return '';

    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date; // difference in milliseconds

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
    if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
}




export function titleCase(str: string) {
  // Convert the entire string to lowercase first
  str = str.toLowerCase();

  // Split the string into an array of words
  const words = str.split(' ');

  // Map over the array to capitalize the first letter of each word
  const titleCasedWords = words.map((word) => {
    // Check if the word is not an empty string
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.substring(1);
    }
    return ''; // Return empty for extra spaces
  });

  // Join the words back together with a space
  return titleCasedWords.join(' ');
}
